import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { TPaths } from "../../../../app";
import en from './en.json';
import ru from './ru.json';

const debugPanelTranslationNs = 'debugPanel' as const;

i18next.addResourceBundle('en', debugPanelTranslationNs, en);
i18next.addResourceBundle('ru', debugPanelTranslationNs, ru);

declare module 'i18next' {
    interface i18nResources {
        [debugPanelTranslationNs]: typeof en;
    }
    interface CustomTypeOptions {
        // custom namespace type if you changed it
        // defaultNS: "ns1"
        // custom resources type
        resources: i18nResources;
    }
}

export type TDebugPanelTranslationPaths = TPaths<typeof en> &
    TPaths<typeof ru>;

export function useDebugPanelTranslations(): (
    key: TDebugPanelTranslationPaths,
    options?: Record<string, string | number>
) => string {
    const { t } = useTranslation(debugPanelTranslationNs);
    return t;
}
